module.exports = __webpack_public_path__ + "static/media/20.b7497e42.JPG";